export const ValidationMessages = {
  requiredField: "Ce champ ne doit pas être vide",
  requiredFile: "Un fichier doit être sélectionné",
  requiredJointFields: "Au moins un de ces champs doit être rempli",
  requiredSelect: "Vous devez sélectionner une option",
  requiredRadio: "Vous devez sélectionner une option",
  requiredDate: "Vous devez sélectionner une date",
  // eslint-disable-next-line
  stringTooShort: "Trop court (min. ${min} caractères)",
  // eslint-disable-next-line
  stringTooLong: "Trop long (max. ${max} caractères)",
  invalidUrl: "Adresse web invalide",
  invalidEmail: "Adresse email invalide",
  invalidPhoneNumber: "N° de téléphone invalide",
  invalidSiren: "N° SIREN invalide",
  expectedMobilePhone: "Un n° de téléphone mobile est attendu",
  invalidPostCode: "Code postal invalide",
  imageFormatPngOrJpg: "L'image doit être au format .jpg ou .png",
  // eslint-disable-next-line
  fileOverXMegaBytes: "Le fichier est trop gros (${max} Mo maximum)",
  needAtLeastOneLowerCase: "Doit contenir au moins une lettre minuscule",
  needAtLeastOneUpperCase: "Doit contenir au moins une lettre majuscule",
  needAtLeastOneDigit: "Doit contenir au moins un chiffre",
  needAtLeastOneSpecialChar: "Doit contenir au moins un caractère spécial",
  passwordConfirmDoesNotMatch: "Le mot de passe est différent",
  newEmailMustDifferFromFormer: "Adresse identique à l'actuelle",
  numberExpected: "La valeur n'est pas un nombre",
  integerExpected: "La valeur n'est pas un nombre entier",
  invalidDate: "Date invalide",
  invalidHour: "Heure invalide",
  tooManyDecimals: "Trop de décimales",
  cobuyerMustDifferFromBuyer: "Le co-acheteur doit être différent de l'acheteur",
  // eslint-disable-next-line
  belowMinValue: "La valeur doit être supérieure ou égale à ${min}",
  // eslint-disable-next-line
  aboveMaxValue: "La valeur doit être inférieure ou égale à ${max}",
  // eslint-disable-next-line
  notAPdf: '"${file}" n\'est pas un document pdf',
  // eslint-disable-next-line
  specificCountRequired: "Vous devez sélectionner exactement ${count} fichiers",
  oneFileRequired: "Vous devez sélectionner exactement un seul fichier",
  noHousingForBlueprint: "Le fichier suivant ne correspond à aucun lot : ",
  // eslint-disable-next-line
  noHousingsForBlueprints: "Les ${count} fichiers suivants ne correspondent à aucun lot : ",
  housingNeedsBlueprint: "Aucun plan correspondant au lot suivant : ",
  // eslint-disable-next-line
  housingsNeedBlueprints: "Aucun plan correspondant aux ${count} lots suivants : ",
};

export const ApiMessages = {
  networkError: "Problème réseau",
  successfulUpdate: "Changements enregistrés",
  partiallySuccessfulUpdate: "Changements partiellement enregistrés",
  emailValidated: "Adresse email enregistrée",
  requestSent: "Demande envoyée",
  passwordUpdated: "Votre mot de passe a bien été changé, vous pouvez maintenant vous connecter",
  userAdded: "Nouvel utilisateur enregistré",
  userDeleted: "Utilisateur supprimé",
  programAdded: "Nouveau programme enregistré",
  programDeleted: "Programme supprimé",
  housingsImported: "Logements importés",
  buyerAdded: "Nouveau contact enregistré",
  buyerDeleted: "Contact supprimé",
  buyerValidated: "Dénonciation confirmée",
  buyerRefused: "Dénonciation refusée",
  optionAdded: "Demande d'option enregistrée",
  optionDeleted: "Option supprimée",
  optionValidated: "Option confirmée",
  optionRefused: "Option refusée",
  reservationAdded: "Demande de réservation enregistrée",
  reservationValidated: "Réservation confirmée",
  reservationRefused: "Réservation refusée",
  reservationCancelled: "Réservation annulée",
  signatureRequestSent: "Demandes de signatures envoyées",
  mandatesCopied: "Mandats mis à jour",
  notificationSent: "Notification envoyée",
  apiTokenCreated: "Jeton créé",
  apiTokenRenewed: "Jeton renouvellé",
  apiTokenDeleted: "Jeton supprimé",
  ar24AccessRequested: "Demande envoyée, veuillez consulter les emails du compte indiqué",
  fundraisingStepCertificateAdded: "Attestation ajoutée",
  fundraisingStepCertificateDeleted: "Attestation supprimée",
  fiscalDeviceAdded: "Dispositif ajouté",
  fiscalDeviceDeleted: "Dispositif supprimé",
  fiscalDeviceApplied: "Dispositif activé",
  fiscalDeviceUnapplied: "Dispositif désactivé",
  sciArticleAdded: "Statuts créés",
  sciArticleUpdated: "Statuts modifiés",
  sciArticleDeleted: "Statuts supprimés",
};

export const AuthenticationMessages = {
  authenticationNeeded: "Vous devez vous identifier pour accéder à cette page",
  missingPermission: "Vous n'avez pas la permission d'accéder à cette page",
  invalidCredentials: "Identifiant ou mot de passe invalide",
};

export const BlueprintsNamingTokens = {
  building: "{bat}",
  number: "{num}",
};
